import {
  PRODUCT_FILTERS_INIT,
  PRODUCT_FILTERS_SEARCH,
  PRODUCT_FILTERS_SET_FILTERS,
  PRODUCT_FILTERS_ORDER,
  PRODUCT_FILTERS_ORDER_FIELD,
} from '../constants/productFiltersTypes';

export const setProductFilters = (filters) => ({ type: PRODUCT_FILTERS_INIT, payload: filters });
export const setProductFiltersSetFilters = (filters) => ({ type: PRODUCT_FILTERS_SET_FILTERS, payload: filters });
export const setProductFiltersOrder = (orderField) => ({ type: PRODUCT_FILTERS_ORDER, payload: orderField });
export const setProductFiltersOrderField = (orderField) => ({ type: PRODUCT_FILTERS_ORDER_FIELD, payload: orderField });

export const setProductFiltersSearch = (filter, value) => {
  return {
    type: PRODUCT_FILTERS_SEARCH,
    payload: { filter, value },
  };
};
